module.exports = __webpack_public_path__ + "01_long_brown.120106c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_long_brown.png
// module id = OCEo
// module chunks = 0